// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style-module--wrapper--3G7-V","img":"style-module--img--3Q8T_","wave":"style-module--wave--2JtRu","text":"style-module--text--5VdME"};